const widgetIds = {
  en: '657af0b15824f540c10a1836',
  nl: '65e87cdf98d8f05a6c0ffe54',
  de: '65e87dec3b2f9f6a0d336b14',
  ja: '65e87f34509860691745a88e',
  fr: '65e6ee3f1dc9711ea2308c40',
  es: '65e87b5e7ede5653302197f5',
};

const currentLanguage = window.AppSettings?.language;
const currentWidgetId = widgetIds[currentLanguage ? currentLanguage : 'en'];

function initUsabillaFeedback() {
  getFAQSections().forEach(section => {
    setupWidgets(section);
  });
}

function getFAQSections() {
  return document.querySelectorAll('li.faq-sub-section');
}

function setupWidgets(section) {
  section.querySelectorAll('.js-usabilla-feedback-widget div').forEach(widget => {
    widget.setAttribute('ub-in-page', currentWidgetId);
    widget.setAttribute('ub-in-page-subcategory', section.getAttribute('data-usabilla-id'));
  });
}

export default initUsabillaFeedback;
